
import { IGenericError, SportCenterAccount } from '@libs/entity-lib';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import * as fromActions from './accounts.actions';

export interface State extends EntityState<SportCenterAccount> {
    loading: boolean;
    error: IGenericError | null;
}

const adapter: EntityAdapter<SportCenterAccount> = createEntityAdapter<SportCenterAccount>({
  selectId: (account: SportCenterAccount) => account.id
});

export const initialState: State = adapter.getInitialState({
  loading: false,
  error: null,
});


export const reducer = createReducer(
  initialState,
  on(fromActions.fetchMultiAccounts, (state) =>  {
    return adapter.removeAll({ ...state, loading: true, error: null });
  }),
  on(fromActions.fetchMultiAccountsSuccessfuly, (state, { accounts }) => {
    return adapter.addMany(accounts, {
      ...state,
      loading: false,
      error: null
    })
  }),
  on(fromActions.fetchMultiAccountsFailed, (state, { error }) =>  adapter.setAll([], { ...state, loading: false, error })),
  on(fromActions.addAccount, (state) =>  ({ ...state, loading: true, error: null })),
  on(fromActions.addAccountSuccessfuly, (state, { account }) => {
    return adapter.addOne(account, {
      ...state,
      loading: false,
      error: null
    })
  }),
  on(fromActions.addAccountFailed, (state, { error }) =>  ({ ...state, loading: false, error })),

  on(fromActions.deleteAccount, (state) =>  ({ ...state, loading: true, error: null })),
  on(fromActions.deleteAccountSuccessfuly, (state, { id }) => {
    return adapter.removeOne(id, {
      ...state,
      loading: false,
      error: null
    })
  }),
  on(fromActions.deleteAccountFailed, (state, { error }) =>  ({ ...state, loading: false, error }))
);

export const { selectAll } = adapter.getSelectors();